import React from "react"
import { StyledClickToDownload, StyledDownloadAnchor } from "../Typography"
import styled from "styled-components"
import report from "../../downloads/abcworld-impact-report-2020.pdf"

const StyledClickToDownloadWrapper = styled.div`
  background-color: #0f6495;
  padding: 1.1em 1.1em;
  padding-left: 30px;
  margin-bottom: 30px;
  /* margin-top: 6%; */
  margin-right: 18%;
  position: relative;
  z-index: 3;
`

const Mobile = () => {
  return (
    <StyledClickToDownloadWrapper>
      <StyledClickToDownload>
        Click{" "}
        <StyledDownloadAnchor
          href={report}
          download="ABC World Impact Report 2020"
        >
          <u>here</u>
        </StyledDownloadAnchor>{" "}
        to download the full report
      </StyledClickToDownload>
    </StyledClickToDownloadWrapper>
  )
}

export default Mobile
